/* Main Product HD — selector de packs + galería.

   Packs: NO son variantes. Solo cambian la CANTIDAD del mismo variant,
   así que el input [data-pack-qty] es lo único que viaja al carrito.

   Galería: cada slide/thumb lleva data-pack = "all" o la cantidad a la
   que pertenece. Al elegir un pack se ocultan las que no correspondan y
   la imagen principal SALTA a la primera foto de ese pack (si existe).

   Miniaturas: siempre una fila. Swipe en táctil; en desktop, flechas y
   rueda del ratón sobre la tira. La rueda solo se captura mientras haya
   recorrido: en los extremos se devuelve al scroll de página para no
   secuestrar la navegación. */

if (!customElements.get('product-main-hd')) {
  customElements.define('product-main-hd', class extends HTMLElement {
    connectedCallback() {
      this.packs = [...this.querySelectorAll('.hd-pack')];
      this.slides = [...this.querySelectorAll('.hd-gallery__slide')];
      this.thumbs = [...this.querySelectorAll('.hd-thumb')];
      this.strip = this.querySelector('.hd-gallery__thumbs');
      this.prevBtn = this.querySelector('[data-thumb-prev]');
      this.nextBtn = this.querySelector('[data-thumb-next]');
      this.qtyInput = this.querySelector('[data-pack-qty]');
      this.note = this.querySelector('[data-pack-note]');
      this.priceNow = this.querySelector('[data-price-now]');
      this.priceWas = this.querySelector('[data-price-was]');
      this.priceSave = this.querySelector('[data-price-save]');
      this.priceBnpl = this.querySelector('[data-price-bnpl]');
      this.form = this.querySelector('.hd-buybox__form');
      this.sticky = this.parentElement.querySelector('[data-stickybuy]');
      this.stickyPrice = this.sticky ? this.sticky.querySelector('[data-sticky-price]') : null;
      this.stickyThumb = this.sticky ? this.sticky.querySelector('[data-sticky-thumb]') : null;
      this.buyTypeBox = this.querySelector('.hd-buytype');
      this.buyTypes = [...this.querySelectorAll('[data-buy-type]')];
      this.planInput = this.querySelector('[data-selling-plan]');
      this.packsWrap = this.querySelector('.hd-packs');
      this.bnpl = this.querySelector('.hd-bnpl');
      this.addEventListener('change', (e) => {
        if (e.target.matches('[data-buy-type]')) this.applyMode();
      });      

      this.addEventListener('click', (e) => {
        const pack = e.target.closest('.hd-pack');
        if (pack) { this.selectPack(pack); return; }
        const thumb = e.target.closest('.hd-thumb');
        if (thumb) { this.show(parseInt(thumb.dataset.go, 10)); return; }
        if (e.target.closest('[data-thumb-prev]')) this.nudge(-1);
        if (e.target.closest('[data-thumb-next]')) this.nudge(1);
      });

      this.addEventListener('keydown', (e) => {
        if (!e.target.closest('.hd-pack')) return;
        const keys = ['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'];
        if (!keys.includes(e.key)) return;
        e.preventDefault();
        const i = this.packs.indexOf(e.target.closest('.hd-pack'));
        const dir = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : -1;
        const next = this.packs[(i + dir + this.packs.length) % this.packs.length];
        this.selectPack(next);
        next.focus();
      });

      if (this.strip) {
        this.strip.addEventListener('wheel', (e) => this.onStripWheel(e),
          { passive: false });
        this.strip.addEventListener('scroll', () => this.syncNav(),
          { passive: true });
        this._r = () => this.syncNav();
        window.addEventListener('resize', this._r);
      }

      this.main = this.querySelector('.hd-gallery__main');
      if (this.main) {
        this.main.addEventListener('wheel', (e) => this.onMainWheel(e),
          { passive: false });
      }

      const preset = this.packs.find(p => p.getAttribute('aria-checked') === 'true')
        || this.packs[0];
      if (preset) this.selectPack(preset);
      this.applyMode();
      this.syncNav();
      this.initSticky();
    }

    initSticky() {
      if (!this.sticky || !this.form) return;

      // El botón de la sticky reenvía el submit al form Ajax real de la
      // buy box: una sola ruta de carrito, cero lógica duplicada.
      const addBtn = this.sticky.querySelector('[data-sticky-add]');
      if (addBtn) {
        addBtn.addEventListener('click', () => {
          this.form.requestSubmit
            ? this.form.requestSubmit()
            : this.form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        });
      }

      // La barra aparece cuando la buy box ha salido de pantalla.
      const box = this.querySelector('.hd-buybox__form');
      if (!box || !('IntersectionObserver' in window)) return;
      this._io = new IntersectionObserver((entries) => {
        entries.forEach(e =>
          this.sticky.classList.toggle('is-visible', !e.isIntersecting));
      }, { rootMargin: '0px 0px -40% 0px' });
      this._io.observe(box);
    }

    disconnectedCallback() {
      if (this._r) window.removeEventListener('resize', this._r);
      if (this._io) this._io.disconnect();
    }

        /* ---------- suscripción ---------- */

    get isSub() {
      const checked = this.buyTypes.find(i => i.checked);
      return !!(checked && checked.value);
    }

    // Suscripción = 1 bote, packs ocultos, sin BNPL. Compra única = packs.
    applyMode() {
      if (!this.buyTypeBox) return;
      const sub = this.isSub;
      if (this.planInput) this.planInput.disabled = !sub;
      if (this.packsWrap) this.packsWrap.hidden = sub;
      if (this.bnpl) this.bnpl.hidden = sub;

      if (!sub) {
        const cur = this.packs.find(p => p.getAttribute('aria-checked') === 'true')
          || this.packs[0];
        if (cur) this.selectPack(cur);
        return;
      }

      const d = this.buyTypeBox.dataset;
      const save = parseInt(d.subSave, 10) || 0;
      if (this.qtyInput) this.qtyInput.value = '1';
      if (this.note) this.note.textContent = d.subNote || '';
      if (this.priceNow) this.priceNow.textContent = d.subNow || '';
      if (this.priceWas) {
        this.priceWas.textContent = d.subWas || '';
        this.priceWas.hidden = save <= 0;
      }
      if (this.priceSave) {
        this.priceSave.textContent = '\u2212' + save + '%';
        this.priceSave.hidden = save <= 0;
      }
      if (this.stickyPrice) this.stickyPrice.textContent = d.subNow || '';
      this.filterGallery('1');
    }
    
    /* ---------- packs ---------- */

    selectPack(pack) {
      this.packs.forEach(p =>
        p.setAttribute('aria-checked', String(p === pack)));

      const qty = pack.dataset.qty;
      if (this.qtyInput) this.qtyInput.value = qty;
      if (this.note) this.note.textContent = pack.dataset.note || '';

      // Los importes vienen ya formateados desde Liquid (filtro money),
      // así que aquí no se calcula ni se formatea nada: solo se copian.
      // Evita divergencias entre el formato de moneda de la tienda y el JS.
      const save = parseInt(pack.dataset.save, 10) || 0;
      if (this.priceNow) this.priceNow.textContent = pack.dataset.now || '';
      if (this.priceWas) {
        this.priceWas.textContent = pack.dataset.was || '';
        this.priceWas.hidden = save <= 0;
      }
      if (this.priceSave) {
        this.priceSave.textContent = '\u2212' + save + '%';
        this.priceSave.hidden = save <= 0;
      }
      if (this.priceBnpl) this.priceBnpl.textContent = pack.dataset.bnpl || '';
      if (this.stickyPrice) this.stickyPrice.textContent = pack.dataset.now || '';

      this.filterGallery(qty);
    }

    filterGallery(qty) {
      const visible = (el) => el.dataset.pack === 'all' || el.dataset.pack === qty;

      this.slides.forEach(s => { s.hidden = !visible(s); });
      this.thumbs.forEach(t => { t.hidden = !visible(t); });

      // Salta a la primera foto PROPIA del pack; si no hay ninguna,
      // a la primera visible.
      const own = this.slides.find(s => s.dataset.pack === qty && !s.hidden);
      const target = own || this.slides.find(s => !s.hidden);
      if (target) this.show(parseInt(target.dataset.index, 10));

      this.syncNav();
    }

    /* ---------- galería ---------- */

    show(index) {
      this.slides.forEach(s =>
        s.classList.toggle('is-on', parseInt(s.dataset.index, 10) === index));
      this.thumbs.forEach(t =>
        t.classList.toggle('is-on', parseInt(t.dataset.go, 10) === index));
      this.centerActiveThumb();

      // La miniatura de la sticky refleja la foto principal activa.
      if (this.stickyThumb) {
        const activeImg = this.slides[index]
          && this.slides[index].querySelector('img');
        if (activeImg && activeImg.currentSrc) {
          this.stickyThumb.src = activeImg.currentSrc;
        }
      }
    }

    centerActiveThumb() {
      if (!this.strip) return;
      const active = this.thumbs.find(t =>
        t.classList.contains('is-on') && !t.hidden);
      if (!active) return;
      // scrollTo manual en lugar de scrollIntoView: este ultimo puede
      // arrastrar tambien el scroll vertical de la pagina.
      const left = active.offsetLeft
        - (this.strip.clientWidth / 2)
        + (active.offsetWidth / 2);
      this.strip.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
    }

    /* ---------- carrusel de miniaturas ---------- */

    nudge(dir) {
      if (!this.strip) return;
      this.strip.scrollBy({
        left: dir * Math.max(120, this.strip.clientWidth * 0.75),
        behavior: 'smooth'
      });
    }

    /* ---------- rueda ---------- */

    // Sobre la FOTO PRINCIPAL: cada gesto avanza una imagen. Solo se
    // captura mientras queden fotos en esa dirección; en la primera y
    // en la última se devuelve el gesto a la página para no dejar al
    // usuario atrapado en la galería.
    onMainWheel(e) {
      const list = this.slides.filter(s => !s.hidden);
      if (list.length < 2) return;

      const delta = Math.abs(e.deltaY) >= Math.abs(e.deltaX) ? e.deltaY : e.deltaX;
      if (delta === 0) return;

      const cur = list.findIndex(s => s.classList.contains('is-on'));
      const next = cur + (delta > 0 ? 1 : -1);
      if (cur < 0 || next < 0 || next >= list.length) return;

      e.preventDefault();

      // Un trackpad dispara decenas de eventos por gesto: sin esta
      // pausa la galería pasaría todas las fotos de golpe.
      const now = Date.now();
      if (now - (this._lastWheel || 0) < 160) return;
      this._lastWheel = now;

      this.show(parseInt(list[next].dataset.index, 10));
    }

    // Sobre la TIRA de miniaturas: desplaza horizontalmente.
    onStripWheel(e) {
      const el = this.strip;
      if (el.scrollWidth <= el.clientWidth + 1) return;

      const delta = Math.abs(e.deltaY) >= Math.abs(e.deltaX) ? e.deltaY : e.deltaX;
      if (delta === 0) return;

      const atStart = el.scrollLeft <= 0;
      const atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 1;
      if ((delta < 0 && atStart) || (delta > 0 && atEnd)) return;

      e.preventDefault();
      el.scrollLeft += delta;
    }

    syncNav() {
      if (!this.strip || !this.prevBtn || !this.nextBtn) return;
      const el = this.strip;
      const overflows = el.scrollWidth > el.clientWidth + 1;
      this.prevBtn.hidden = !overflows || el.scrollLeft <= 0;
      this.nextBtn.hidden = !overflows ||
        el.scrollLeft + el.clientWidth >= el.scrollWidth - 1;
    }
  });
}